import { useAppSelector } from "../store/hooks";

// Base spacing & typography (same for both modes)
const baseTheme = {
  spacing: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 20,
    xxl: 24,
  },
  borderRadius: {
    sm: 4,
    md: 8,
    lg: 12,
  },
  typography: {
    label: {
      fontSize: 14,
      fontWeight: "500" as const,
    },
    input: {
      fontSize: 16,
      fontWeight: "400" as const,
    },
    error: {
      fontSize: 12,
      fontWeight: "400" as const,
    },
  },
};

const lightColors = {
  primary: "#3b82f6",
  primaryDark: "#2563eb",
  secondary: "#64748b",
  danger: "#ef4444",
  success: "#22c55e",
  text: "#1e293b",
  textLight: "#64748b",
  border: "#e2e8f0",
  background: "#ffffff",
  placeholder: "#94a3b8",
  disabled: "#f1f5f9",
};

const darkColors = {
  primary: "#60a5fa",
  primaryDark: "#3b82f6",
  secondary: "#94a3b8",
  danger: "#f87171",
  success: "#4ade80",
  text: "#f1f5f9",
  textLight: "#cbd5e1",
  border: "#334155",
  background: "#0f172a",
  placeholder: "#64748b",
  disabled: "#1e293b",
};

export const useAppTheme = () => {
  const mode = useAppSelector((state) => state.theme.mode);
  const colors = mode === "light" ? lightColors : darkColors;

  return {
    mode,
    colors,
    spacing: baseTheme.spacing,
    borderRadius: baseTheme.borderRadius,
    typography: baseTheme.typography,
  };
};
